export enum StatusTypeEnum {
    CANCEL = 'CANCELLED',
    NOT_CANCELLED = 'NOT CANCELLED',
  }
